import React, { createContext, useContext, useState } from 'react';

// Crear el contexto
const SearchContext = createContext();

// Hook personalizado para usar el contexto
export const useSearch = () => {
  const context = useContext(SearchContext);
  if (!context) {
    throw new Error('useSearch debe ser usado dentro de un SearchProvider');
  }
  return context;
};

// Proveedor del contexto
export const SearchProvider = ({ children }) => {
  const [searchQuery, setSearchQuery] = useState('');

  const value = {
    searchQuery,
    setSearchQuery
  };

  return (
    <SearchContext.Provider value={value}>
      {children}
    </SearchContext.Provider>
  );
};